/* script */
//
//
//

import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';

const __vue_script__ = {
    name: 'CancelMeetingButton',

    props: {
        event: {
            type: Object,
            required: true
        },

        action: {
            type: Object,
            required: true
        },

        context: {
            type: Object,
            required: true
        }
    },

    computed: {
        /** @returns {boolean} */
        enabled() {
            return !this.context.fp_readonly;
        }
    },

    methods: {
        /**
         * Prompts the user for deletion confirmation.
         *
         * @returns {void}
         */
        async promptCancellation() {
            this.$emit('before-cancellation-prompt');

            this.$modal.show(DialogComponent, {
                title: this.$t('meetings.details.cancellation_prompt_title'),
                text: this.$t('meetings.details.cancellation_prompt'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn',
                        handler: () => {
                            this.$emit('dismiss-cancellation-prompt');
                            this.$modal.hide('cancel-meeting-dialog');
                        },
                    },
                    {
                        title: this.$t('meetings.details.actions.cancel_no_notify'),
                        default: true,
                        class: 'btn',
                        handler: () => {
                            this.cancel();
                            this.$modal.hide('cancel-meeting-dialog');
                        }
                    },
                    {
                        title: this.$tc('meetings.details.actions.cancel', 1),
                        handler: () => {
                            this.cancel(true);
                            this.$modal.hide('cancel-meeting-dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            }, {
                name: 'cancel-meeting-dialog',
                clickToClose: false,
                height: 'auto'
            });
        },

        /**
         * Performs the cancellation of the current meeting.
         */
        async cancel(notify = false) {
            try {
                if (!this.action.appscriptUrl) {
                    throw new Error('No cancel appscript found');
                }

                console.info('[CancelMeetingButton] Cancelling meeting', this.context);
                await this.$services.appScripts.callAppScript(this.event._id, this.action.appscriptUrl, { ids: [this.context._id], notify });

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.messages.meeting_cancel_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$emit('change');
            } catch (error) {
                console.error('[CancelMeetingButton] An error occurred while trying to cancel the meeting:', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later'),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { type: "button" },
          on: { click: _vm.promptCancellation },
        },
        [_vm._v(_vm._s(_vm.$t("meetings.details.cancel_meeting")))]
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/CancelMeetingButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__